import React from 'react';
import Sparkline from 'sparkline-svg';

import { ColumnHeaderSortable } from '../../DataTable/index.jsx';

import Column from './base.jsx';

// Using one instance to avoid useless memory allocations
const sparkline = new Sparkline([]);

const columnOptions = {
  id: 'col-sparkline-7d',
  title: 'Last 7 Days Chart'
};

class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return 'Last 7 Days';
  }

  get overlayText() {
    return 'Sparkline in last 7 days';
  }
}


class DetailColumn extends React.Component {
  render() {
    let prices = this.props.row.sparkline7d?.[0];
    if(!prices?.length) {
      return (<td></td>);
    } 
    // Focus on the line changes
    const min = Math.min(...prices);
    prices = prices.map(p => (p - min) * 10000);

    // Configure Sparkline
    const strokeColor = prices[0] > prices[prices.length -1] ? '#dc3545' : '#0F9B40';
    sparkline.setValues(prices);
    sparkline.setStroke(strokeColor);
    return (
      <td className="cs-asset-table__sparkline">
          <img className="cs-asset-table__sparkline__image" loading="lazy" alt={`${this.props.row.title} 7d chart`} src={sparkline.dataUri}/>
      </td>
    );
  }
}


class Sparkline7d extends Column {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  sortAscending(a, b) {
    if (a.priceChange7d < b.priceChange7d) {
      return -1;
    }
    if (a.priceChange7d > b.priceChange7d) {
      return 1;
    }
    return super.sortAscending(a, b);
  }

  sortDescending(a, b) {
    if (a.priceChange7d < b.priceChange7d) {
      return 1;
    }
    if (a.priceChange7d > b.priceChange7d) {
      return -1;
    }
    return super.sortDescending(a, b);
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default Sparkline7d;

